/**
 * Created by 胜 on 2017/6/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import LectureDialog from './lecture/LectureDialog';
import {renderMoney} from '../utils';
import Config from '../config';

import '../styles/GiftDialog.css';

class GiftDialog extends Component {
    constructor() {
        super();
        this.state = {
            value: 1,
            closeText: '打包1份赠礼',
            giftValueFirst: [1, 2, 5],
            giftValueSecond: [10, 20, 50],
            giftValueSelected: 1
        };
        this.plusbtnHandler = this.plusbtnHandler.bind(this);
        this.subbtnHandler = this.subbtnHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.giftNumSelHandler = this.giftNumSelHandler.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose() {
        this.props.dispatch({
            type: 'LECTURE_HIDE_GIFT_BAR'
        });
        this.setState({
            lecturePrice: 0,
            giftValueSelected: 1,
        });
    }

    render() {
        let {closeText, giftValueFirst, giftValueSecond, giftValueSelected} = this.state;
        let {giftNum, money, showGiftBar} = this.props;

        return (
            <div className="gift-bar">
                <LectureDialog
                    title={<span style={{color: '#3cc51f', fontSize: '1.1rem'}}>豪爽赠礼给好友</span>}
                    closeText={closeText}
                    onClick={this.submitHandler}
                    onRequestClose={this.onRequestClose}
                    show={showGiftBar}>
                    <div className="cs-number-item">
                        <div className="gift-num-text">赠送数量</div>
                        <div className="weui-flex git-num-box">
                            {giftValueFirst.map((v, i) => (
                                <span key={v} className={"weui-flex__item " + (i === 1 && "gift-middle")} data-value={v}
                                      onClick={this.giftNumSelHandler}>
                                    <a
                                       className={giftValueSelected === v ? "weui-btn weui-btn_primary gift-num-selected" : "weui-btn weui-btn_plain-default gift-num"}>
                                      {v}
                                    </a>
                                </span>
                            ))}
                        </div>
                        <div className="weui-flex git-num-box">
                            {giftValueSecond.map((v, i) => (
                                <span key={v} className={"weui-flex__item " + (i === 1 && "gift-middle")} data-value={v}
                                      onClick={this.giftNumSelHandler}>
                                    <a
                                       className={giftValueSelected === v ? "weui-btn weui-btn_primary gift-num-selected" : "weui-btn weui-btn_plain-default gift-num"}>
                                      {v}
                                    </a>
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="weui-flex cs-number-item">
                        <div className="weui-flex__item">豪爽赠送</div>
                        <div className="weui-flex__item weui-flex cs-gift-num">
                            <a href="#" className="cs-number-sub cs-number"
                               onClick={this.subbtnHandler}>-</a>
                            <input pattern="[0-9]*" type="number" className="cs-number-input" value={giftNum} min="1"
                                   disabled/>
                            <a className="cs-number-plus cs-number"
                               onClick={this.plusbtnHandler}>+</a>
                        </div>
                        <div className="weui_cell_ft" style={{display: "none"}}> 0</div>
                    </div>

                    <div className="weui-flex cs-number-item cs-gift-total-money">
                        <div className="weui-flex__item text-right cs-gift-total">
                            <p className="total" style={{margin: '0 auto'}}>
                                总计：￥{this.state.lecturePrice ? renderMoney(this.state.lecturePrice) : renderMoney(money)}
                            </p>
                            <p className="text-medium">好友可免费领取，永久有效</p>
                        </div>
                    </div>
                </LectureDialog>
            </div>
        )
    }

    plusbtnHandler() {
        let giftNum = this.props.giftNum;
        let money = this.props.money;
        this.setState({
            lecturePrice: (giftNum + 1) * money,
            closeText: '打包' + (giftNum + 1) + '份赠礼',
            giftValueSelected: 0
        });
        this.props.dispatch({
            type: 'LECTURE_SET_GIFT_NUM',
            payload: {
                giftNum: this.props.giftNum + 1
            }
        })
    }

    subbtnHandler() {
        let giftNum = this.props.giftNum === 1 ? 1 : (this.props.giftNum - 1);
        let money = this.props.money;
        this.setState({
            lecturePrice: (giftNum * money),
            closeText: '打包' + giftNum + '份赠礼',
            giftValueSelected: 0
        });
        this.props.dispatch({
            type: 'LECTURE_SET_GIFT_NUM',
            payload: {
                giftNum: giftNum
            }
        })
    }

    giftNumSelHandler(e) {
        let {money} = this.props;
        let giftValueSelected = parseInt(e.currentTarget.dataset.value, 10);
        let lecturePrice = giftValueSelected * money;
        let closeText = '打包' + giftValueSelected + '份赠礼';
        this.setState({giftValueSelected, lecturePrice, closeText});
        this.props.dispatch({
            type: 'LECTURE_SET_GIFT_NUM',
            payload: {
                giftNum: giftValueSelected
            }
        })
    }

    submitHandler() {
        this.props.dispatch({type: 'LECTURE_HIDE_GIFT_BAR'});
        let {lectureId, giftNum} = this.props;
        this.props.dispatch({
            type: 'PAY_LECTURE',
            payload: {
                params: {
                    product: 'gift_lecture',
                    gift_count: giftNum,
                    lecture_id: lectureId,
                },
                success: () => {
                    this.props.dispatch({
                        type: 'LECTURE_HIDE_GIFT_BAR'
                    });
                    this.props.dispatch({
                        type: 'MTA_CLICK',
                        payload: 'lecture_giftpayfinish'
                    });
                    window.location = Config.MAIN_URL + `/lecture/pay_success?lecture_id=${lectureId}&st=pay_gift_lecture`;
                }
            }
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_giftpay'
        })
    }
}

export default connect((state) => ({
    lectureId: state.lecture.lecture.id,
    giftNum: state.lecture.giftNum,
    money: state.lecture.lecture.limit_money ? state.lecture.lecture.limit_money.money : state.lecture.lecture.money,
    showGiftBar: state.lecture.showGiftBar,
}))(GiftDialog)




// WEBPACK FOOTER //
// ./src/components/GiftDialog.js